<div class="imprint-data-protection-links pt-4">
  <ul
    class="d-flex flex-column list-unstyled justify-content-between align-items-center align-items-sm-start my-3"
    [ngClass]="{ 'gap-2': increasedFontSize }"
  >
    <li *ngFor="let link of portalSettings.links.visibility.leftSidebar; trackBy: trackByLink">
      <a
        class="link-dark pointer"
        target="_blank"
        [ngClass]="{ 'font-size-base': increasedFontSize }"
        [href]="portalSettings.links.urls[link]"
      >
        {{ link | translate }}
      </a>
    </li>
  </ul>
</div>
